import { render, staticRenderFns } from "./LocalPathImportSkuForm.vue?vue&type=template&id=4bb0c7cf"
import script from "./LocalPathImportSkuForm.vue?vue&type=script&lang=js"
export * from "./LocalPathImportSkuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports